import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../../assets/veoliaLogo.png";
import axios from "axios";
import apiUrl from "../../ApiEndpoint/config";
import { useAuthContext} from "../../utils/AuthContext";
import { ThreeDots } from "react-loader-spinner";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();

  sessionStorage.setItem("currentPath", location.pathname);
  const { user } = useAuthContext();

  const [isLoading, setIsLoading] = useState(false);

  const userRole = user?.roles || [];
  const userAccess = user?.accessControlsge || [];
  const userOrg = user?.accessOrg || [];

  const normalize = (str) => (str || "").toString().trim().toLowerCase();

  // -----------------------------
  // Access validation
  // -----------------------------
  const hasAccess = () => {
    const superRoles = (process.env.REACT_APP_ALLOWED_SUPERUSER_ROLES?.split(",") || []).map(normalize);
    const developerRoles = (process.env.REACT_APP_ALLOWED_DEVELOPER_ROLES?.split(",") || []).map(normalize);
    const adminRoles = (process.env.REACT_APP_ALLOWED_ADMIN_ROLES?.split(",") || []).map(normalize);
    const sgeAccessRoles = (process.env.REACT_APP_ALLOWED_SGE_ACCESS?.split(",") || []).map(normalize);
    const AccessOrg = (process.env.REACT_APP_ALLOWED_ORG_ACCESS_SIB?.split(",") || []).map(normalize);

    // Role check
    const roleAllowed = (Array.isArray(userRole) ? userRole : [userRole])
      .map(normalize)
      .some(r => superRoles.includes(r) || developerRoles.includes(r) || adminRoles.includes(r));

    // Access control check
    const accessAllowed = (Array.isArray(userAccess) ? userAccess : [userAccess])
      .map(normalize)
      .some(r => sgeAccessRoles.includes(r));

    // Org check
    const orgAllowed = (Array.isArray(userOrg) ? userOrg : [userOrg])
      .map(normalize)
      .some(r => AccessOrg.includes(r));


    return roleAllowed && accessAllowed && orgAllowed;
  };

  // -----------------------------
  // Health checks
  // -----------------------------
  // const checkService1Health = async () => {
  //   try {
  //     const res = await axios.get(process.env.REACT_APP_SAML_HEALTH_PROBE_URL);
  //     return res.data.status === "ok";
  //   } catch (err) {
  //     console.error("Service1 health check failed", err);
  //     return false;
  //   }
  // };

  // const checkService2Health = async (token) => {
  //   try {
  //     const res = await axios.get(`${apiUrl}/health-check-sgdata`, {
  //       headers: { Authorization: `Bearer ${token}` },
  //     });
  //     return res.status === 200 && res.data.status === "ok";
  //   } catch (err) {
  //     console.error("Service2 health check failed", err);
  //     return false;
  //   }
  // };

  // -----------------------------
  // Validate all services & access
  // -----------------------------
  const validateAll = async (token) => {
    setIsLoading(true);

    // const [service1Ok, service2Ok] = await Promise.all([
    //   checkService1Health(),
    //   // checkService2Health(token),
    // ]);

    // if (!service1Ok || !service2Ok || !hasAccess()) {
    //   console.warn("Access validation failed");
    //   sessionStorage.clear();
    //   setIsLoading(false);
    //   return;
    // }

    //  if (!service1Ok  || !hasAccess()) {
    //   console.warn("Access validation failed");
    //   sessionStorage.clear();
    //   setIsLoading(false);
    //   return;
    // }

    // Brief loader before redirect
    setTimeout(() => navigate("/home", { replace: true }), 1000);
  };

  // -----------------------------
  // On mount: handle token from SAML redirect
  // -----------------------------
  useEffect(() => {
    const token = new URLSearchParams(location.search).get("token");
    if (!token) return;

    sessionStorage.setItem("access_token", token);
    validateAll(token);
  }, [location.search]);

  // -----------------------------
  // Redirect to SAML login
  // -----------------------------
  const handleSamlLogin = () => {
    window.location.href = process.env.REACT_APP_SAML_LOGIN_URL_SIB;
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <img src={logo} alt="Veolia Logo" style={styles.logo} />
        <h2 style={styles.title}>Welcome to Smart Growth Engine</h2>
        <button onClick={handleSamlLogin} style={styles.button} disabled={isLoading}>
          Access with your Veolia ID
        </button>
      </div>

      {isLoading && (
        <div style={styles.popupOverlay}>
          <div style={styles.popupCard}>
            <ThreeDots
              height={60}
              width={60}
              color="#007bff"
              ariaLabel="three-dots-loading"
              visible={true}
            />
          </div>
        </div>
      )}
    </div>
  );
};

// -----------------------------
// Styles
// -----------------------------
const styles = {
  page: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    position: "relative",
  },
  card: {
    backgroundColor: "#fff",
    padding: "3rem",
    borderRadius: "12px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
    textAlign: "center",
    width: "100%",
    maxWidth: "480px",
    zIndex: 1,
  },
  logo: { height: "100px", marginBottom: "2rem" },
  title: { marginBottom: "1rem", fontSize: "2rem", fontWeight: "700", color: "#005073" },
  button: {
    padding: "0.75rem 2rem",
    fontSize: "1rem",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    width: "100%",
  },
  popupOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    height: "100vh",
    width: "100vw",
    backgroundColor: "rgba(0,0,0,0.3)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  popupCard: {
    backgroundColor: "#fff",
    padding: "2rem 3rem",
    borderRadius: "12px",
    boxShadow: "0 15px 30px rgba(0,0,0,0.2)",
    textAlign: "center",
    maxWidth: "200px",
    width: "90%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};

export default Login;
